module.exports = __webpack_public_path__ + "static/media/logo-tower.2bca4bdd.svg";